import { SavingsAndInvestmentsIncomeByYear } from './interfaces';

export const rates: SavingsAndInvestmentsIncomeByYear = {
    2023: {
      heffingsVrijVermogen: 57_000,
      rendementBankTegoed: 0.92,
      rendementBeleggingen: 6.17,
      rendementSchulden: 2.46,
      schuldenDrempel: 3_400,
      tariefBox3: 32
    },
    2024: {
      heffingsVrijVermogen: 57_000,
      rendementBankTegoed: 1.03,
      rendementBeleggingen: 6.04,
      rendementSchulden: 2.47,
      schuldenDrempel: 3_700,
      tariefBox3: 36
    }
};
